import React, { useEffect, useState, useRef } from "react";
import Layout from "../../layout/default";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Card,
  CardBody,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  Select,
  Stack,
  Text,
  Tooltip,
  useToast,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  UnorderedList,
  ListItem,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  HStack,
  Tag,

  MenuList,
  Menu,
  MenuButton,
  CheckboxGroup,
  Checkbox,
  useMediaQuery,
  Radio,
  RadioGroup,
  VStack,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import axios from "axios";

import "react-quill/dist/quill.snow.css";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import Seo, { schema } from "../../utilities/Seo";
import { isCoachKycComplete } from "../../utilities/coachKycRules";


const proficiencyLevelOption = [
  { id: 0, name: "Beginner", value: "beginner" },
  { id: 1, name: "Intermediate", value: "intermediate" },
  { id: 2, name: "Advance", value: "advance" },
];

// Reusable styled FormErrorMessage component
const StyledFormErrorMessage = ({ children, ...props }) => (
  <FormErrorMessage
    fontSize="sm"
    mt={1}
    wordBreak="break-word"
    whiteSpace="normal"
    {...props}
  >
    {children}
  </FormErrorMessage>
);

const CourseCreation = () => {
  // Mobile responsiveness
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const [isTablet] = useMediaQuery("(max-width: 1024px)");
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedImagesError, setSelectedImagesError] = useState(false);
  const [courseName, setCourseName] = useState("");
  const [courseNameError, setCourseNameError] = useState(false);
  const [isItCamp, setIsItCamp] = useState(false);
  const [campName, setCampName] = useState("");
  const [campNameError, setCampNameError] = useState(false);
  const [maximumGroupSize, setMaximumGroupSize] = useState(1);
  const [maximumGroupSizeError, setMaximumGroupSizeError] = useState(false);
  const [sessionType, setSessionType] = useState("Group");
  const [categoryType, setCategoryType] = useState("");
  const [categories, setCategories] = useState([]);
  const [courseDescription, setCourseDescription] = useState("");
  const [courseDescriptionError, setCourseDescriptionError] = useState(false);
  const [courseAmeneties, setCourseAmeneties] = useState("");
  const [btnIsLoading, setBtnIsLoading] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [isEnd, setIsEnd] = useState(false);
  const [timeFrom, setTimeFrom] = useState("");
  const [timeTo, setTimeTo] = useState("");
  const [timingMode, setTimingMode] = useState("same");
  const [daySchedules, setDaySchedules] = useState([]);
  const [daySchedulesError, setDaySchedulesError] = useState(false);
  const [classType, setClassType] = useState("class");
  const [startDate, setStartDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [price, setPrice] = useState("");
  const [priceError, setPriceError] = useState(false);
  const [fees30, setFees30] = useState("");
  const [fees45, setFees45] = useState("");
  const [fees60, setFees60] = useState("");
  const [fees30Error, setFees30Error] = useState(false);
  const [fees45Error, setFees45Error] = useState(false);
  const [fees60Error, setFees60Error] = useState(false);
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [carryThings, setCarryThings] = useState("");
  const [timeFromError, setTimeFromError] = useState(false);
  const [timeToError, setTimeToError] = useState(false);
  const [courseFacility, setCourseFacility] = useState("");
  const [categoryError, setCategoryError] = useState(false);
  const [facilityError, setFacilityError] = useState(false);
  const [selectedDaysError, setSelectedDaysError] = useState(false);
  const [coach, setCoach] = useState({});
  const [proficiencyLevel, setProficiencyLevel] = useState([]);
  const [showSlotConflict, setShowSlotConflict] = useState(false);
  const [conflictResult, setConflictResult] = useState({});
  const [academyStartTime, setAcademyStartTime] = useState(null);
  const [academyEndTime, setAcademyEndTime] = useState(null);
  const [kycChecked, setKycChecked] = useState(false);
  const [requiredFields, setRequiredFields] = useState([]);
  const [isProficiencyMenuOpen, setIsProficiencyMenuOpen] = useState(false);
  const [priceFieldsEnabled, setPriceFieldsEnabled] = useState({
    price30: false,
    price45: false,
    price60: false,
    coursePrice: false
  });

  const toast = useToast();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = sessionStorage.getItem("admintoken").split(" ")[1];
  const [isOpen3, setIsOpen3] = useState(false);
  const onClose3 = () => setIsOpen3(false);
  const onOpen3 = () => setIsOpen3(true);

  const calculateMinutesDifference = (startTime, endTime) => {
    if (!startTime || !endTime) return 0;
    const start = new Date(startTime);
    const end = new Date(endTime);
    const diffMs = end - start;
    return Math.round(diffMs / (1000 * 60));
  };

  useEffect(() => {
    const fetchRequiredFields = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/field-config?entity=coach`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setRequiredFields(response.data || []);
      } catch (error) {
        console.error("Error fetching required fields:", error);
      }
    };
    fetchRequiredFields();
  }, []);

  // Ensure proficiency level is properly initialized
  useEffect(() => {
    // Reset proficiency level to empty array to prevent any default selections
    setProficiencyLevel([]);
  }, []);

  useEffect(() => {
    let minutesDiff = 0;
    if (timingMode === "same") {
      minutesDiff = calculateMinutesDifference(timeFrom, timeTo);
    } else if (timingMode === "different" && daySchedules.length > 0) {
      // Use max duration across all day slots so price fields enable if any slot meets the duration
      const durations = daySchedules
        .filter((s) => s.startTime && s.endTime)
        .map((s) => calculateMinutesDifference(s.startTime, s.endTime));
      minutesDiff = durations.length > 0 ? Math.max(...durations) : 0;
    }
    const enabledFields = {
      price30: minutesDiff >= 30,
      price45: minutesDiff >= 45,
      price60: minutesDiff >= 60,
      coursePrice: minutesDiff >= 30 && (timingMode === "same" ? timeTo !== "" : daySchedules.some((s) => s.startTime && s.endTime))
    };
    setPriceFieldsEnabled(enabledFields);
    if (!enabledFields.price30 && fees30) {
      setFees30("");
      setFees30Error(false);
    }
    if (!enabledFields.price45 && fees45) {
      setFees45("");
      setFees45Error(false);
    }
    if (!enabledFields.price60 && fees60) {
      setFees60("");
      setFees60Error(false);
    }
    if (!enabledFields.coursePrice && price) {
      setPrice("");
      setPriceError(false);
    }
  }, [timeFrom, timeTo, timingMode, daySchedules]);

  useEffect(() => {
    if (timingMode !== "different") return;
    setDaySchedules((prev) => {
      const byDay = {};
      prev.forEach((s) => { byDay[s.day] = { startTime: s.startTime, endTime: s.endTime }; });
      return selectedDays.map((day) => ({
        day,
        startTime: byDay[day]?.startTime ?? null,
        endTime: byDay[day]?.endTime ?? null,
      }));
    });
  }, [timingMode, selectedDays]);


  useEffect(() => {
    if (coach?.academyAvailability?.endDate && coach?.academyAvailability?.startDate) {
      const coachStartDate = new Date(coach?.academyAvailability?.startDate);
      const coachEndDate = new Date(coach?.academyAvailability?.endDate);
      const yearsDifference = (coachEndDate - coachStartDate) / (1000 * 60 * 60 * 24 * 365.25);
      
      if (yearsDifference < 9.5 || yearsDifference > 10.5) {
        setIsEnd(true);
      }
    }
  }, [coach]);

  // Close proficiency menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProficiencyMenuOpen) {
        const proficiencyMenu = document.getElementById('proficiency-menu');
        if (proficiencyMenu && !proficiencyMenu.contains(event.target)) {
          setIsProficiencyMenuOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProficiencyMenuOpen]);

  // Toast management to prevent multiple toasts
  const activeToastRef = useRef(null);

  const showToast = (title, description, status = "error", duration = 2000) => {
    // Close any existing toast
    if (activeToastRef.current) {
      toast.close(activeToastRef.current);
    }

    // Show new toast and store its ID
    activeToastRef.current = toast({
      title,
      description,
      status,
      duration,
      position: "top",
      isClosable: true,
      onCloseComplete: () => {
        activeToastRef.current = null;
      },
    });
  };

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Get available days from coach's academy availability
  const getAvailableDays = () => {
    if (coach?.academyAvailability?.days && coach.academyAvailability.days.length > 0) {
      return coach.academyAvailability.days;
    }
    return days; // fallback to all days if no restriction
  };

  const availableDays = getAvailableDays();

  // Get date range restrictions from coach's academy availability
  const getDateRestrictions = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of day for accurate comparison

    if (coach?.academyAvailability?.startDate && coach?.academyAvailability?.endDate) {
      const coachStartDate = new Date(coach.academyAvailability.startDate);
      const coachEndDate = new Date(coach.academyAvailability.endDate);

      return {
        minDate: coachStartDate > today ? coachStartDate : today, // Use whichever is later
        maxDate: coachEndDate
      };
    }
    return {
      minDate: today, // Always start from today, never allow past dates
      maxDate: null // No max date restriction
    };
  };

  const dateRestrictions = getDateRestrictions();

  const getCurrentTime = () => {
    const currentDate = new Date();
    const currentHours = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    return new Date(0, 0, 0, currentHours, currentMinutes);
  };

  const currentTime = getCurrentTime();

  const date = new Date(startDate);
  const today = new Date();

  const includesToday =
    date.getDate() <= today.getDate() &&
    date.getMonth() <= today.getMonth() &&
    date.getFullYear() <= today.getFullYear();

  const filterPassedTime = (time) => {
    if (!timeFrom) return true;
    const selectedTime = new Date(time);
    const minAllowedTime = getMinTime();
    return selectedTime >= minAllowedTime;
  };

  const minTime = includesToday ? currentTime : undefined;

  const getMinTime = () => {
    if (timeFrom) {
      const selectedTime = new Date(timeFrom);
      // Add 30 minutes to the start time as minimum end time
      const minAllowedTime = new Date(selectedTime.getTime() + 30 * 60000);
      
      // Round up to the next 15-minute interval to align with timeIntervals={15}
      const minutes = minAllowedTime.getMinutes();
      const roundedMinutes = Math.ceil(minutes / 15) * 15;
      const roundedMinAllowedTime = new Date(minAllowedTime);
      roundedMinAllowedTime.setMinutes(roundedMinutes);
      if (roundedMinutes >= 60) {
        roundedMinAllowedTime.setHours(roundedMinAllowedTime.getHours() + 1);
        roundedMinAllowedTime.setMinutes(0);
      }
      
      return roundedMinAllowedTime;
    }
    return academyStartTime || new Date(0, 0, 0, 0, 0);
  };

  function getLastDateOfCurrentYear() {
    var today = new Date(); // Get current date
    var currentYear = today.getFullYear(); // Get current year
    var lastDate = new Date(currentYear, 11, 31); // Set to December 31st of the current year
    return formatDateToYYYYMMDD(lastDate);
  }

  const isCoachEndDateSpecific = () => {
    if (!coach?.academyAvailability?.endDate || !coach?.academyAvailability?.startDate) {
      return false;
    }
    const coachStartDate = new Date(coach.academyAvailability.startDate);
    const coachEndDate = new Date(coach.academyAvailability.endDate);
    const yearsDifference = (coachEndDate - coachStartDate) / (1000 * 60 * 60 * 24 * 365.25);
    
    return yearsDifference < 9.5 || yearsDifference > 10.5;
  };

  const getTime = (time) => {
    const tempdate = new Date(time);

    const hours = tempdate.getHours(); // Get the hour component (0-23)
    const minutes = tempdate.getMinutes(); // Get the minute component (0-59)

    // Format the time as needed (e.g., to a string with leading zeros)
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;

    return formattedTime;
  };

  function formatDateToYYYYMMDD(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2); // Add leading zero if needed
    const day = `0${date.getDate()}`.slice(-2); // Add leading zero if needed

    return `${year}-${month}-${day}`;
  }

  function daysDifference(startDate, endDate, daysArray) {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const start = new Date(startDate);
    const end = new Date(endDate);

    let count = 0;
    let currentDate = new Date(start);

    while (currentDate <= end) {
      if (daysArray.includes(daysOfWeek[currentDate.getDay()])) {
        count++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return count;
  }

  // ### Final Save ###
  const saveHandler = async () => {
    // Prevent double submission
    if (btnIsLoading) return;

    setBtnIsLoading(true);

    // Calculate the effective end date for "Never" option
    let effectiveEndDate = getLastDateOfCurrentYear();
    
    if (startDate) {
      const startYear = new Date(startDate).getFullYear();
      const currentYear = new Date().getFullYear();
      if (startYear > currentYear) {
        const lastDateOfStartYear = new Date(startYear, 11, 31);
        effectiveEndDate = formatDateToYYYYMMDD(lastDateOfStartYear);
      }
    }

    // If coach has availability end date, use whichever is earlier
    if (coach?.academyAvailability?.endDate) {
      const coachEndDate = new Date(coach.academyAvailability.endDate);
      const yearEndDate = new Date(effectiveEndDate);
      effectiveEndDate = coachEndDate < yearEndDate ? coachEndDate : yearEndDate;
    }

    let lastDateOfYear = formatDateToYYYYMMDD(effectiveEndDate);

    if (sessionType?.name === "Individual") {
      setMaximumGroupSize(1);
    }

    // Proficiency validation
    if (!proficiencyLevel || (Array.isArray(proficiencyLevel) ? proficiencyLevel.length === 0 : proficiencyLevel === "")) {
      setBtnIsLoading(false);
      showToast(
        "Please select proficiency level",
        "You must select a proficiency level before submitting.",
        "warning"
      );
      return;
    }

    if (courseName.length <= 3) {
      setBtnIsLoading(false);
      setCourseNameError(true);
      showToast(
        "Invalid Course Name",
        "Course name must be at least 4 characters long.",
        "warning"
      );
      return;
    }

    if (!courseDescription || courseDescription === "<p><br></p>") {
      setCourseDescriptionError(true);
      setBtnIsLoading(false);
      showToast(
        "Description Required",
        "Please enter a description for the course.",
        "warning"
      );
      return;
    }

    if (!startDate) {
      setBtnIsLoading(false);
      setStartDateError(true);
      showToast(
        "Start Date Required",
        "Please select a start date.",
        "warning"
      );
      return;
    }

    if (isEnd && !endDate) {
      setBtnIsLoading(false);
      showToast(
        "End Date Required",
        "Please select an end date.",
        "warning"
      );
      return;
    }

    if (!selectedDays.length) {
      setBtnIsLoading(false);
      setSelectedDaysError(true);
      showToast(
        "Days Required",
        "Please select at least one day for the course.",
        "warning"
      );
      return;
    }

    if (timingMode === "same") {
      if (!timeFrom || !timeTo) {
        if (!timeTo) setTimeToError(true);
        if (!timeFrom) setTimeFromError(true);
        setBtnIsLoading(false);
        showToast(
          "Time Required",
          "Please select both start and end time.",
          "warning"
        );
        return;
      }
      // Validate time gap (minimum 30 minutes)
      const startTime = new Date(timeFrom);
      const endTime = new Date(timeTo);
      const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
      const endMinutes = endTime.getHours() * 60 + endTime.getMinutes();
      const timeDiffInMinutes = endMinutes - startMinutes;
      if (timeDiffInMinutes < 30) {
        setBtnIsLoading(false);
        showToast(
          "Invalid Time Gap",
          "The time gap between start time and end time should be at least 30 minutes.",
          "warning"
        );
        return;
      }
    } else {
      // timingMode === "different": require each selected day to have start and end with 30 min gap
      const missing = daySchedules.some(
        (s) => !s.startTime || !s.endTime
      );
      const invalidGap = daySchedules.some((s) => {
        if (!s.startTime || !s.endTime) return false;
        const startM = new Date(s.startTime).getHours() * 60 + new Date(s.startTime).getMinutes();
        const endM = new Date(s.endTime).getHours() * 60 + new Date(s.endTime).getMinutes();
        return endM - startM < 30;
      });
      if (missing || invalidGap) {
        setDaySchedulesError(true);
        setBtnIsLoading(false);
        showToast(
          "Time Required",
          "Please set start and end time for each selected day (minimum 30 minutes gap).",
          "warning"
        );
        return;
      }
    }

    if (classType === "class") {
      const enabled30 = priceFieldsEnabled.price30;
      const enabled45 = priceFieldsEnabled.price45;
      const enabled60 = priceFieldsEnabled.price60;

      const val30 = fees30 !== "";
      const val45 = fees45 !== "";
      const val60 = fees60 !== "";

      const anyFilled =
        (enabled30 && val30) ||
        (enabled45 && val45) ||
        (enabled60 && val60);

      if (!anyFilled) {
        if (enabled30) setFees30Error(true);
        if (enabled45) setFees45Error(true);
        if (enabled60) setFees60Error(true);

        showToast(
          "Price Required",
          "Please enter at least one price for the enabled durations.",
          "warning"
        );
        setBtnIsLoading(false);
        return;
      }
    }

    if (classType !== "class") {
      if (price === "") {
        setBtnIsLoading(false);
        setPriceError(true);
        showToast(
          "Price Required",
          "Please enter a price for the course.",
          "warning"
        );
        return;
      }
    }

    if (!categoryType) {
      setCategoryError(true);
      setBtnIsLoading(false);
      showToast(
        "Category Required",
        "Please select a category for the course.",
        "warning"
      );
      return;
    }

    if (!courseFacility) {
      setFacilityError(true);
      setBtnIsLoading(false);
      showToast(
        "Facility Required",
        "Please select a facility for the course.",
        "warning"
      );
      return;
    }

    if (classType === "course" && isItCamp ? !campName : false) {
      setCampNameError(true);
      setBtnIsLoading(false);
      showToast(
        "Camp Name Required",
        "Please enter a camp name.",
        "warning"
      );
      return;
    }

    // Validate maximum group size for Group sessions (allowed 1-20)
    if (sessionType === "Group" && classType === "course") {
      const groupSize = Number(maximumGroupSize);
      if (!maximumGroupSize || groupSize < 1 || groupSize > 20) {
        setMaximumGroupSizeError(true);
        setBtnIsLoading(false);
        showToast(
          "Invalid Group Size",
          "Maximum group size must be between 1 and 20."
        );
        return;
      }
    }

    // Validations //
    if (!id) {
      setBtnIsLoading(false);
      showToast(
        "Please select coach, before creating the course",
        "A coach must be selected to create a course.",
        "warning"
      );
      return;
    }
    if (!selectedDays || selectedDays.length === 0) {
      setBtnIsLoading(false);
      showToast(
        "Please select at least one day to continue",
        "You must select at least one day for the course schedule.",
        "warning"
      );
      return;
    }


    const effectiveEnd = endDate ? new Date(endDate) : new Date(lastDateOfYear);
    if (
      daysDifference(new Date(startDate), effectiveEnd, selectedDays) < selectedDays.length
    ) {
      setBtnIsLoading(false);
      setSelectedDaysError(true);
      showToast(
        "Selected Days is not available between selected date range",
        "Please select different days or adjust the date range.",
        "warning"
      );
      return;
    }

    const resolvedStartTime = timingMode === "same"
      ? getTime(timeFrom)
      : (daySchedules[0]?.startTime ? getTime(daySchedules[0].startTime) : getTime(timeFrom));
    const resolvedEndTime = timingMode === "same"
      ? getTime(timeTo)
      : (daySchedules[0]?.endTime ? getTime(daySchedules[0].endTime) : getTime(timeTo));
    const startDateTime = `${formatDateToYYYYMMDD(startDate)}T${resolvedStartTime}:00`;
    const endDateTime = `${endDate
        ? formatDateToYYYYMMDD(endDate)
        : formatDateToYYYYMMDD(lastDateOfYear)
      }T${resolvedEndTime}:00`;

    let isAvailable = await getAvailableSlots(`${id}`);

    if (!isAvailable) {
      setBtnIsLoading(false);
      showToast(
        "Conflicting time slots",
        "The selected time slots conflict with existing courses. Please choose different times.",
        "warning"
      );
      return;
    }

    const selectedUrl = categories.filter((x) => x.name === categoryType);

    // main working body //
    let raw = JSON.stringify({
      courseName: `${courseName.replace(/\s+/g, " ").trim()}`,
      description: `${courseDescription}`,
      images:
        selectedImages.length <= 0
          ? [{ url: selectedUrl[0]?.image }]
          : selectedImages,
      coach_id: `${id}` || "",
      coachName: (coach?.firstName || "") + " " + (coach?.lastName || ""),
      category: `${categoryType}`,
      customImage: selectedImages.length <= 0 ? false : true,

      sessionType:
        classType === "course" ? `${sessionType.toLowerCase()}` : "individual",
      classType: classType,
      camp: isItCamp,
      campName: `${campName.replace(/\s+/g, " ").trim()}`,
      fees: {
        feesCourse: classType !== "class" ? Number(price) : "",
        fees30: classType === "class" ? Number(fees30) : "",
        fees45: classType === "class" ? Number(fees45) : "",
        fees60: classType === "class" ? Number(fees60) : "",
        fees:
          classType === "class"
            ? fees30 && fees60
              ? Number(fees30)
              : fees30 && fees60
                ? Number(fees60)
                : fees30 && fees60
            : Number(price),
      },
      maxGroupSize: maximumGroupSize !== "" ? maximumGroupSize : 1,
      amenitiesProvided: courseAmeneties,
      proficiency: proficiencyLevel,
      facility: facilities.find((x) => x.name === courseFacility),
      coachEmail: coach.email,
      dates: {
        startDate: startDateTime,
        endDate: endDateTime,
        startTime: timingMode === "same" ? getTime(timeFrom) : resolvedStartTime,
        endTime: timingMode === "same" ? getTime(timeTo) : resolvedEndTime,
        days: selectedDays,
        timingMode,
        ...(timingMode === "different" && {
          daySchedules: daySchedules.map((s) => ({
            day: s.day,
            startTime: getTime(s.startTime),
            endTime: getTime(s.endTime),
          })),
        }),
      },
      ...(classType === "class" && !isEnd && { isEndDate: "never" }),
      whatYouHaveToBring: carryThings,
      cancellationPolicy: cancellationPolicy,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/course`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: raw,
    };

    axios
      .request(config)
      .then((response) => {
        toast({
          title: "Course created successfully",
          status: "success",
          duration: 4000,
          isClosable: true,
          position: "top",
        });
        navigate(`/course-page`);
        setBtnIsLoading(false);
        setCourseDescriptionError(false);
        setCourseName("");
        setCourseNameError(false);
        setCampName("");
        setCampNameError(false);
        setMaximumGroupSize(1);
        setMaximumGroupSizeError(false);
        setCourseDescription("");
        setCourseAmeneties("");
        setStartDateError(false);
        setEndDate("");
        setPriceError(false);
        setFees30("");
        setFees45("");
        setFees60("");
        setStartDate("");
        setTimeFrom("");
        setTimeTo("");
        setTimingMode("same");
        setDaySchedules([]);
        setDaySchedulesError(false);
        setSelectedDaysError(false);
        setSelectedDays([]);
        setCancellationPolicy("");
        setCarryThings("");
        setCategoryType({});
        setCourseFacility({});
        setFees30Error(false);
        setFees45Error(false);
        setFees60Error(false);
        setSelectedImages([]);
        setCategoryError(false);
        setFacilityError(false);
        setBtnIsLoading(false);
        setSelectedImagesError(false);
      })
      .catch((error) => {
        setBtnIsLoading(false);
        if (error.response.status === 403) {
          toast({
            title: "You don't have an access to perform this action",
            status: "warning",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
        } else {
          toast({
            title: error.response.data.error,
            status: "error",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
        }
      });
  };

  const getCategories = async () => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/category`
      );
      setCategories(response.data.data);
    } catch (error) {
      console.log(error);
      if (error.response.status === 403) {
        toast({
          title: "You don't have an access to perform this action",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something went wrong please try again later",
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const getCoachDetails = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/coach/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        const coachData = response?.data;

        if (!kycChecked && !isCoachKycComplete(requiredFields, coachData)) {
          setKycChecked(true);
          showToast(
            "KYC Details Required",
            "Coach must complete KYC verification before creating courses. Please complete all required KYC details first.",
            "error",
            6000
          );
          navigate(`/coach-page/details/${id}`);
          return;
        }

        setFacilities(coachData?.linkedFacilities || []);
        setCoach(coachData);

        if (coachData?.academyAvailability) {
          const { startTime, endTime } = coachData.academyAvailability;
          if (startTime && endTime) {
            const [sh, sm] = startTime.split(":");
            const [eh, em] = endTime.split(":");

            // Create proper Date objects for today's date with the specified times
            const today = new Date();
            const startTimeObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Number(sh), Number(sm) || 0);
            const endTimeObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), Number(eh), Number(em) || 0);

            setAcademyStartTime(startTimeObj);
            setAcademyEndTime(endTimeObj);

          }
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.status === 403) {
          toast({
            title: "You don't have an access to perform this action",
            status: "warning",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
        } else {
          toast({
            title: "Something went wrong please try again later",
            status: "error",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
        }
      });
  };

  const handleRadioChange = (e) => {
    const value = e.target.value === "yes";
    setIsItCamp(value);
  };

  // Fix for the time picker filters
  const filterTimeForStart = (time) => {
    const selectedTime = new Date(time);

    // If start date is today, don't allow past times
    if (startDate) {
      const today = new Date();
      const isToday = startDate.toDateString() === today.toDateString();
      if (isToday) {
        const currentTime = new Date();
        currentTime.setSeconds(0, 0); // Reset seconds and milliseconds for accurate comparison
        if (selectedTime < currentTime) {
          return false;
        }
      }
    }

    if (!academyStartTime || !academyEndTime) {
      return true;
    }

    // Convert academy times to Date objects for comparison
    const academyStart = new Date(academyStartTime);
    const academyEnd = new Date(academyEndTime);

    // If start date is today, only check current time and academy hours
    if (startDate) {
      const today = new Date();
      const isToday = startDate.toDateString() === today.toDateString();
      if (isToday) {
        const currentTime = new Date();
        currentTime.setSeconds(0, 0);
        // Must be after current time AND within academy hours
        return selectedTime >= currentTime && selectedTime >= academyStart && selectedTime <= academyEnd;
      }
    }

    // For future dates, allow any time within academy hours
    return selectedTime >= academyStart && selectedTime <= academyEnd;
  };

  // Per-day start-time filter for "different time for each day" mode
  const filterTimeForStartPerDay = (schedule, time) => {
    const selectedTime = new Date(time);

    if (!academyStartTime || !academyEndTime) {
      return true;
    }

    const academyStart = new Date(academyStartTime);
    const academyEnd = new Date(academyEndTime);

    // Only block past times when the course start date is today AND the schedule day is today.
    if (startDate && schedule?.day) {
      const today = new Date();
      const isStartDateToday = startDate.toDateString() === today.toDateString();

      if (isStartDateToday) {
        const weekdayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const todayLabel = weekdayLabels[today.getDay()];

        if (schedule.day === todayLabel) {
          const currentTime = new Date();
          currentTime.setSeconds(0, 0);
          return (
            selectedTime >= currentTime &&
            selectedTime >= academyStart &&
            selectedTime <= academyEnd
          );
        }
      }
    }

    return selectedTime >= academyStart && selectedTime <= academyEnd;
  };

  const filterTimeForEnd = (time) => {
    // Convert time to minutes since midnight for easier comparison
    const selectedTime = new Date(time);
    const selectedMinutes = selectedTime.getHours() * 60 + selectedTime.getMinutes();
  
    // If no start time is selected, allow any time within academy hours
    if (!timeFrom) {
      if (!academyStartTime || !academyEndTime) {
        return true;
      }
      const academyStartMinutes = academyStartTime.getHours() * 60 + academyStartTime.getMinutes();
      const academyEndMinutes = academyEndTime.getHours() * 60 + academyEndTime.getMinutes();
      return selectedMinutes >= academyStartMinutes && selectedMinutes <= academyEndMinutes;
    }
  
    // Calculate 30-minute minimum from start time
    const startTime = new Date(timeFrom);
    const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
    const minAllowedMinutes = startMinutes + 30;
    
    // Round up to the next 15-minute interval
    const roundedMinAllowedMinutes = Math.ceil(minAllowedMinutes / 15) * 15;
    
  
    // If academy times aren't set, only check 30-minute minimum (rounded to 15-min intervals)
    if (!academyStartTime || !academyEndTime) {
      return selectedMinutes >= roundedMinAllowedMinutes;
    }
  
    // Convert academy times to minutes for comparison
    const academyStartMinutes = academyStartTime.getHours() * 60 + academyStartTime.getMinutes();
    const academyEndMinutes = academyEndTime.getHours() * 60 + academyEndTime.getMinutes();
    
    // Use the later of: 30 minutes after start time (rounded) OR academy start time
    const effectiveMinMinutes = Math.max(roundedMinAllowedMinutes, academyStartMinutes);
    
    return selectedMinutes >= effectiveMinMinutes && selectedMinutes <= academyEndMinutes;
  };

  const isDifferentDayEndTimeAllowed = (schedule, time) => {
    if (!schedule?.startTime) return true;

    const startM = new Date(schedule.startTime).getHours() * 60 + new Date(schedule.startTime).getMinutes();
    const selectedM = new Date(time).getHours() * 60 + new Date(time).getMinutes();

    if (selectedM - startM < 30) return false;

    if (academyStartTime && academyEndTime) {
      const aStart = academyStartTime.getHours() * 60 + academyStartTime.getMinutes();
      const aEnd = academyEndTime.getHours() * 60 + academyEndTime.getMinutes();
      return selectedM >= aStart && selectedM <= aEnd;
    }

    return true;
  };
  // Update your DatePicker components like this:

  function getLastDayOfYear() {
    let currentDate = new Date();
    currentDate.setMonth(11);
    currentDate.setDate(31);
    return currentDate.toISOString();
  }

  const getAvailableSlots = async (id, value, endTime) => {
    // Calculate the effective end date for "Never" option
    let effectiveEndDate = getLastDateOfCurrentYear();
    
    if (startDate) {
      const startYear = new Date(startDate).getFullYear();
      const currentYear = new Date().getFullYear();
      if (startYear > currentYear) {
        const lastDateOfStartYear = new Date(startYear, 11, 31);
        effectiveEndDate = formatDateToYYYYMMDD(lastDateOfStartYear);
      }
    }

    // If coach has availability end date, use whichever is earlier
    if (coach?.academyAvailability?.endDate) {
      const coachEndDate = new Date(coach.academyAvailability.endDate);
      const yearEndDate = new Date(effectiveEndDate);
      effectiveEndDate = coachEndDate < yearEndDate ? formatDateToYYYYMMDD(coachEndDate) : effectiveEndDate;
    }

    let lastDateOfYear = effectiveEndDate;
    const baseStartTime =
      timingMode === "different" && daySchedules[0]?.startTime
        ? getTime(daySchedules[0].startTime)
        : getTime(timeFrom);
    const baseEndTime =
      timingMode === "different" && daySchedules[0]?.endTime
        ? getTime(daySchedules[0].endTime)
        : endTime
        ? getTime(endTime)
        : getTime(timeTo);

    const buildPayloadForDays = (daysForRequest) => {
      let effectiveStartTime = baseStartTime;
      let effectiveEndTime = baseEndTime;

      if (
        timingMode === "different" &&
        daysForRequest.length === 1 &&
        daySchedules.length > 0
      ) {
        const targetDay = daysForRequest[0];
        const sched = daySchedules.find((s) => s.day === targetDay);
        if (sched?.startTime) {
          effectiveStartTime = getTime(sched.startTime);
        }
        if (sched?.endTime) {
          effectiveEndTime = getTime(sched.endTime);
        }
      }

      const startDateTime = `${formatDateToYYYYMMDD(
        startDate
      )}T${effectiveStartTime}:00`;
      const endDateTime = `${endDate ? formatDateToYYYYMMDD(endDate) : lastDateOfYear
        }T${effectiveEndTime}:00`;

      return JSON.stringify({
        dates: {
          startDate: startDateTime,
          endDate: endDateTime,
          startTime: effectiveStartTime,
          endTime: effectiveEndTime,
          days: daysForRequest,
          timingMode,
          ...(timingMode === "different" &&
            daySchedules.length > 0 && {
              daySchedules: daySchedules
                .filter((s) => daysForRequest.includes(s.day))
                .map((s) => ({
                  day: s.day,
                  startTime: s.startTime ? getTime(s.startTime) : "",
                  endTime: s.endTime ? getTime(s.endTime) : "",
                })),
            }),
        },
      });
    };

    const makeRequest = (daysForRequest) =>
      axios.request({
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_BASE_URL}/api/course/availableSlots/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: buildPayloadForDays(daysForRequest),
      });

    if (timingMode === "same") {
      const daysForRequest = selectedDays && selectedDays.length > 0 ? [...selectedDays] : [];
      const response = await makeRequest(daysForRequest);
      setConflictResult(response.data);
      if (response.data.message === "Slots available") {
        setShowSlotConflict(false);
        return true;
      } else {
        setShowSlotConflict(true);
        return false;
      }
    }

    if (!selectedDays || selectedDays.length <= 1) {
      const response = await makeRequest(
        selectedDays && selectedDays.length === 1 ? [selectedDays[0]] : []
      );
      setConflictResult(response.data);
      if (response.data.message === "Slots available") {
        setShowSlotConflict(false);
        return true;
      } else {
        setShowSlotConflict(true);
        return false;
      }
    }

    // Different time mode with multiple days: one API call per day in parallel (each day has different times)
    const responses = await Promise.allSettled(
      selectedDays.map((day) => makeRequest([day]))
    );

    const aggregatedConflicts = [];
    let anyFailure = false;
    let allAvailable = true;
    let mergedResult = null;

    responses.forEach((result) => {
      if (result.status === "fulfilled") {
        const data = result.value?.data || {};

        if (!mergedResult) {
          mergedResult = {
            ...data,
            conflictingDates: [],
          };
        }

        if (Array.isArray(data.conflictingDates)) {
          aggregatedConflicts.push(...data.conflictingDates);
        }

        if (data.message !== "Slots available") {
          allAvailable = false;
        }
      } else {
        anyFailure = true;
        allAvailable = false;
      }
    });

    if (anyFailure) {
      throw new Error(
        "Failed to fetch available slots for one or more selected days"
      );
    }

    if (!mergedResult) {
      mergedResult = {
        message: "Slots available",
        conflictingDates: [],
      };
    }

    mergedResult = {
      ...mergedResult,
      conflictingDates: aggregatedConflicts,
      message: aggregatedConflicts.length > 0 ? "Conflicting slots" : "Slots available",
    };

    setConflictResult(mergedResult);
    setShowSlotConflict(aggregatedConflicts.length > 0);
    return aggregatedConflicts.length === 0;
  };

  useEffect(() => {
    if (
      timingMode === "different" &&
      selectedDays.length > 0 &&
      startDate
    ) {
      getAvailableSlots(`${id}`);
    }
  }, [
    timingMode,
    selectedDays,
    daySchedules,
    startDate,
    endDate,
    id,
  ]);

  const formatSlotDate = (date) => {
    const originalDateString = date;
    const originalDate = new Date(originalDateString);

    const year = originalDate.getUTCFullYear();
    const month = originalDate.getUTCMonth() + 1;
    const day = originalDate.getUTCDate();

    const formattedDateString = `${day}-${month < 10 ? "0" : ""
      }${month}-${year}`;

    return formattedDateString;
  };

  // Group conflicts with same course, date range, and time into one row (merge days)
  const groupConflictingDates = (dates) => {
    if (!Array.isArray(dates) || dates.length === 0) return [];
    const dayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const sortDays = (arr) => [...arr].sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
    const key = (c) =>
      `${c?.courseId ?? ""}|${c?.startDate ?? ""}|${c?.endDate ?? ""}|${c?.conflictingStartTime ?? ""}|${c?.conflictingEndTime ?? ""}`;
    const map = new Map();
    for (const c of dates) {
      const k = key(c);
      if (!map.has(k)) {
        map.set(k, { ...c, conflictingDays: sortDays(c?.conflictingDays || []) });
      } else {
        const existing = map.get(k);
        const merged = sortDays([...new Set([...(existing.conflictingDays || []), ...(c?.conflictingDays || [])])]);
        map.set(k, { ...existing, conflictingDays: merged });
      }
    }
    return Array.from(map.values());
  };

  const handleFileChange = async (e) => {
    try {
      const file = e.currentTarget.files[0];
      setSelectedImagesError(false);

      if (file && file.size > 10 * 1024 * 1024) {
        toast({
          title: "Please select a file less than 10 MB.",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/coach/uploadImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const url = response?.data?.url;
      if (url) {
        toast({
          title: "Image Uploaded Successfully",
          status: "success",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title:
            "Something went wrong while uploading image, please try again later",
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }

      setSelectedImages([...selectedImages, { url: url }]);
    } catch (error) {
      toast({
        title:
          "Something went wrong while uploading image, please try again later",
        status: "error",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
    }
  };

  const deleteImageFiles = async (url, index) => {
    try {
      const formData = new FormData();
      formData.append("url", url);

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/coach/uploadImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast({
        title: "Image removed Successfully",
        status: "success",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
    } catch (error) {
      console.log(error);
      toast({
        title:
          "Something went wrong while removing image, please try again later",
        status: "error",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getCategories();
    if (requiredFields.length > 0) {
      getCoachDetails();
    }
  }, [requiredFields]);

  const showTooltip30 = timeFrom && timeTo && !priceFieldsEnabled.price30;
  const showTooltip45 = timeFrom && timeTo && !priceFieldsEnabled.price45;
  const showTooltip60 = timeFrom && timeTo && !priceFieldsEnabled.price60;
  const showTooltipCoursePrice = timeFrom && timeTo && !priceFieldsEnabled.coursePrice;

  const clearFeeErrors = () => {
  setFees30Error(false);
  setFees45Error(false);
  setFees60Error(false);
};

  return (
    <Box bgColor={"#f2f2f2"}>
      <Seo
        title="Create Training Schedule | KhelSport"
        description="Create new training schedules and courses. Set up coaching sessions, manage pricing, and configure course details."
        canonical={`https://khelcoach.com/courses/create/${id || ''}`}
        url={`https://khelcoach.com/courses/create/${id || ''}`}
        jsonLd={schema.course({
          name: 'Create Training Schedule',
          description: 'Create new training schedules and courses on KhelSport platform',
          url: `https://khelcoach.com/courses/create/${id || ''}`,
          provider: {
            name: 'KhelSport',
            sameAs: ['https://khelcoach.com']
          }
        })}
      />
      <Layout title="Create Training Schedule">
        {/* Breadcrumb */}
        <Flex justifyContent={"space-between"} alignItems={"center"} mb={6}>
          <Flex justifyContent={"center"} alignItems={"center"}>
            <Button
              variant="ghost"
              size={{ base: "xs", md: "sm" }}
              leftIcon={<IoArrowBackCircleOutline fontSize={"24px"} />}
              onClick={() => navigate(-1)}
              _hover={{ bg: "gray.100" }}
              color="gray.700"
              fontWeight="bold"
              className="p-0"
            >
            </Button>
            <Breadcrumb fontWeight="medium" fontSize="sm">

              <BreadcrumbItem>
                <Link to="/course-page">Training Schedule</Link>
              </BreadcrumbItem>

              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">Create Training Schedule</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </Flex>
        </Flex>
        <Card>
          <CardBody>
            {/* Course name */}
            <FormControl isInvalid={courseNameError}>
              <FormLabel>Training Schedule Name <Text as="span" color="red.500">*</Text></FormLabel>
              <Input
                type="text"
                placeholder="Enter training schedule name"
                name="course-name"
                id="course-name"
                min={10}
                value={courseName}
                autoComplete="off"
                onChange={(e) => {
                  setCourseName(e.target.value);
                  if (e.target.value !== "") {
                    setCourseNameError(false);
                  } else {
                    setCourseNameError(true);
                  }
                  if (
                    e.target.value.length > 100 ||
                    e.target.value.length < 2
                  ) {
                    setCourseNameError(true);
                  } else {
                    setCourseNameError(false);
                  }
                }}
              />
              {courseNameError && (
                <StyledFormErrorMessage>
                  Please enter training schedule name, atleast 3 characters and maximum
                  100 characters
                </StyledFormErrorMessage>
              )}
            </FormControl>
            {/* Description */}
            <FormControl mt={6} isInvalid={courseDescriptionError}>
              <FormLabel>Description <Text as="span" color="red.500">*</Text></FormLabel>
              <ReactQuill
                theme="snow"
                value={courseDescription}
                onChange={(value) => {
                  setCourseDescription(value);
                  if (value === "" || value === "<p><br></p>") {
                    setCourseDescriptionError(true);
                  } else {
                    setCourseDescriptionError(false);
                  }
                }}
              />
              {courseDescriptionError && (
                <StyledFormErrorMessage>
                  Please enter description
                </StyledFormErrorMessage>
              )}
            </FormControl>
          </CardBody>
        </Card>
        <Card mt={4}>
          <CardBody>
            {/* Course Image */}
            <FormControl mt={6}>
              <FormLabel>Course Image</FormLabel>
              <Box mt={3}>
                <Input
                  id={`kycDocuments.documentImg.${0}.url`}
                  name={`kycDocuments.documentImg.${0}.url`}
                  type="file"
                  accept="image/*"
                  disabled={selectedImages.length >= 10}
                  onChange={(e) => handleFileChange(e, 0)}
                />
                {selectedImagesError && (
                  <Text color={"red.500"} fontSize={"sm"} mt={1}>
                    Please select atleast one document image
                  </Text>
                )}
                {selectedImages.length >= 10 && (
                  <Text color={"orange.500"} fontSize={"sm"} mt={1}>
                    Maximum 10 images allowed
                  </Text>
                )}
                {selectedImages.length > 0 && (
                  <Flex
                    wrap={"wrap"}
                    mt={3}
                    gap={2}
                    justifyContent={{ base: "center", md: "flex-start" }}
                  >
                    {selectedImages.map((preview, index) => (
                      <Box
                        key={index}
                        textAlign={"center"}
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="md"
                        p={2}
                        bg="gray.50"
                      >
                        <a
                          href={`${preview?.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Image
                            src={preview?.url}
                            alt={`Preview ${index}`}
                            height={isMobile ? "80px" : "120px"}
                            width={isMobile ? "80px" : "120px"}
                            objectFit="cover"
                            borderRadius="md"
                            border="1px solid"
                            borderColor="gray.300"
                          />
                        </a>
                        <Button
                          colorScheme="red"
                          size="sm"
                          mt={1}
                          onClick={() => {
                            deleteImageFiles(preview?.url, index);
                            const updatedImages = selectedImages.filter(
                              (image) => image.url !== preview.url
                            );
                            setSelectedImages(updatedImages);

                            // Reset file input when all images are removed
                            if (updatedImages.length === 0) {
                              const fileInput = document.getElementById(`kycDocuments.documentImg.${0}.url`);
                              if (fileInput) {
                                fileInput.value = '';
                              }
                            }
                          }}
                        >
                          Remove
                        </Button>
                      </Box>
                    ))}
                  </Flex>
                )}
              </Box>
            </FormControl>
          </CardBody>
        </Card>

        {/*  Slot */}
        <Card mt={4}>
          <CardBody>
            {/* Radion btn - session type */}
            <Flex justifyContent={"center"} alignItems={"center"}>
              <Stack direction="row">
                <Box mr={6}>
                  <input
                    id="notification-method-class"
                    type="radio"
                    value=""
                    required
                    checked={classType === "class"}
                    onChange={(e) => {
                      e.target.checked && setClassType("class");
                      endDate ? setIsEnd(true) : setIsEnd(false);
                    }}
                  />
                  <label
                    htmlFor="notification-method-class"
                    className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-black-300"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                    }}
                  >
                    Session
                  </label>
                </Box>
                <Box>
                  <input
                    id="notification-method-course"
                    type="radio"
                    value=""
                    required
                    checked={classType === "course"}
                    onChange={(e) => {
                      e.target.checked && setClassType("course");
                      setIsEnd(true);
                    }}
                  />
                  <label
                    htmlFor="notification-method-course"
                    className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-black-300"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                    }}
                  >
                    Course
                  </label>
                </Box>
              </Stack>
            </Flex>
            {/* Date row: Start Date | End Date (screenshot order) */}
            {coach?.academyAvailability?.startDate && coach?.academyAvailability?.endDate && (
              <Text fontSize="sm" color="gray.600" mb={2}>
                Available from: {(() => {
                  const startDate = new Date(coach.academyAvailability.startDate);
                  const endDate = new Date(coach.academyAvailability.endDate);
                  const months = ["January", "February", "March", "April", "May", "June",
                                  "July", "August", "September", "October", "November", "December"];
                  const formatDate = (date) => `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
                  return `${formatDate(startDate)} to ${formatDate(endDate)}`;
                })()}
              </Text>
            )}
            <Flex direction={{ base: "column", md: "row" }} gap={4} my={3} alignItems="flex-start">
              <FormControl flex={1} isInvalid={startDateError}>
                <FormLabel>Select Start Date <Text as="span" color="red.500">*</Text></FormLabel>
                <DatePicker
                  placeholderText="Select start date"
                  className={
                    startDateError
                      ? "my-custom-datepicker dateError"
                      : "my-custom-datepicker"
                  }
                  selected={startDate}
                  onKeyDown={(e) => e.preventDefault()}
                  onChange={(date) => {
                    setEndDate("");
                    setStartDate(date);
                    if (date !== "") {
                      setStartDateError(false);
                    } else {
                      setStartDateError(true);
                    }
                  }}
                  minDate={dateRestrictions.minDate}
                  maxDate={dateRestrictions.maxDate}
                  dateFormat="dd MMMM yyyy"
                  popperPlacement="bottom-start"
                  popperClassName="datepicker-popper-date"
                  filterDate={(date) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return date >= today;
                  }}
                />
                {startDateError && (
                  <StyledFormErrorMessage>
                    Please select start date
                  </StyledFormErrorMessage>
                )}
              </FormControl>
              {classType === "course" && (
                <FormControl flex={1}>
                  <FormLabel>Select End Date <Text as="span" color="red.500">*</Text></FormLabel>
                  <DatePicker
                    placeholderText="Select end date"
                    className="my-custom-datepicker"
                    selected={endDate}
                    onKeyDown={(e) => e.preventDefault()}
                    onChange={(date) => {
                      setEndDate(date);
                    }}
                    minDate={
                      startDate
                        ? new Date(startDate).setDate(new Date(startDate).getDate())
                        : dateRestrictions.minDate
                    }
                    maxDate={dateRestrictions.maxDate}
                    dateFormat="dd MMMM yyyy"
                    popperPlacement="bottom-start"
                    popperClassName="datepicker-popper-date"
                  />
                </FormControl>
              )}
              {classType === "class" && (
                <Box flex={1}>
                  <Flex alignItems="center" gap={4} mb={2} flexWrap={{ base: "wrap", md: "nowrap" }}>
                    <FormLabel mb={0}>End Date</FormLabel>
                    <Stack direction="row" alignItems="center">
                      <Box mr={6}>
                        <input
                          id="horizontal-list-radio-license-never"
                          type="radio"
                          required
                          value=""
                          defaultChecked={!isEnd}
                          disabled={isCoachEndDateSpecific()}
                          onChange={(e) => {
                            e.target.checked
                              ? setIsEnd(false)
                              : setIsEnd(true);
                          }}
                          name="list-radio"
                        />
                        <label
                          htmlFor="horizontal-list-radio-license-never"
                          style={{
                            marginLeft: "8px",
                            cursor: isCoachEndDateSpecific() ? "not-allowed" : "pointer",
                            fontSize: "1rem",
                            fontWeight: "600",
                            opacity: isCoachEndDateSpecific() ? 0.5 : 1,
                          }}
                        >
                          Never
                        </label>
                      </Box>
                      <Box>
                        <input
                          id="horizontal-list-radio-license-on"
                          type="radio"
                          required
                          value=""
                          defaultChecked={isEnd}
                          onChange={(e) => {
                            e.target.checked
                              ? setIsEnd(true)
                              : setIsEnd(false);
                          }}
                          name="list-radio"
                        />
                        <label
                          htmlFor="horizontal-list-radio-license-on"
                          style={{
                            marginLeft: "8px",
                            cursor: "pointer",
                            fontSize: "1rem",
                            fontWeight: "600",
                          }}
                        >
                          On
                        </label>
                      </Box>
                    </Stack>
                    {/* {isEnd && (
                      <FormLabel mb={0} ml={2}>
                        Select End Date <Text as="span" color="red.500">*</Text>
                      </FormLabel>
                    )} */}
                  </Flex>
                  {isEnd && (
                    <DatePicker
                      placeholderText="Select end date"
                      className="my-custom-datepicker"
                      selected={endDate}
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => {
                        setEndDate(date);
                      }}
                      minDate={
                        startDate
                          ? new Date(startDate).setDate(
                            new Date(startDate).getDate()
                          )
                          : dateRestrictions.minDate
                      }
                      maxDate={dateRestrictions.maxDate}
                      dateFormat="dd MMMM yyyy"
                      popperPlacement="bottom-start"
                      popperClassName="datepicker-popper-date"
                    />
                  )}
                </Box>
              )}
            </Flex>

            {/* Weekly timing: same vs different */}
            <FormControl my={5}>
              <FormLabel>Weekly timing <Text as="span" color="red.500">*</Text></FormLabel>
              <RadioGroup
                value={timingMode}
                onChange={(value) => {
                  setTimingMode(value);
                  setDaySchedulesError(false);
                  if (value === "different" && selectedDays.length > 0) {
                    setDaySchedules(selectedDays.map((day) => ({
                      day,
                      startTime: timeFrom || null,
                      endTime: timeTo || null,
                    })));
                  }
                }}
              >
                <Stack direction="row" spacing={8} mt={2} flexWrap="wrap">
                  <Radio value="same" colorScheme="blue">
                    Same time for all days
                  </Radio>
                  <Radio value="different" colorScheme="blue">
                    Different time for each day
                  </Radio>
                </Stack>
              </RadioGroup>
            </FormControl>

            {/* Select Days */}
            <FormControl my={5} isInvalid={selectedDaysError}>
              <FormLabel>Select Days <Text as="span" color="red.500">*</Text></FormLabel>
              {coach?.academyAvailability?.days && coach.academyAvailability.days.length > 0 && (
                <Text fontSize="sm" color="gray.600" mb={2}>
                  Available days: {coach.academyAvailability.days.join(", ")}
                </Text>
              )}

              <Flex
                wrap="wrap"
                justifyContent={{ base: "center", md: "flex-start" }}
                gap={2}
                maxW="100%"
                overflow="hidden"
              >
                {days.map((day, i) => {
                  const isAvailable = availableDays.includes(day);
                  return (
                    <Button
                      key={i}
                      type="button"
                      onClick={() => {
                        if (!isAvailable) return; // Don't allow selection of unavailable days

                        setSelectedDays(
                          selectedDays.includes(day)
                            ? selectedDays.filter(
                              (selected) => selected !== day
                            )
                            : [...selectedDays, day]
                        );
                        if (!day) {
                          setSelectedDaysError(true);
                        } else {
                          setSelectedDaysError(false);
                        }
                      }}
                      colorScheme={
                        selectedDays.includes(day) ? "telegram" : "gray"
                      }
                      size={isMobile ? "sm" : "md"}
                      minW={isMobile ? "45px" : "60px"}
                      flex={isMobile ? "1 1 auto" : "none"}
                      maxW={isMobile ? "calc(14.28% - 4px)" : "none"}
                      isDisabled={!isAvailable}
                      opacity={isAvailable ? 1 : 0.4}
                      cursor={isAvailable ? "pointer" : "not-allowed"}
                      _hover={isAvailable ? {} : { bg: "gray.200" }}
                    >
                      {day}
                    </Button>
                  );
                })}
              </Flex>
              <StyledFormErrorMessage>
                {selectedDaysError ? "Select the Days" : ""}
              </StyledFormErrorMessage>
            </FormControl>
            <Divider />

            {/* Start Time && End time (same) OR Time for each day (different) */}
            {coach?.academyAvailability?.startTime && coach?.academyAvailability?.endTime && (
              <Text fontSize="sm" color="gray.600" mb={2}>
                Available start time: {(() => {
                  const time = coach.academyAvailability.startTime;
                  const [hours, minutes] = time.split(':');
                  const hour12 = hours % 12 || 12;
                  const ampm = hours >= 12 ? 'PM' : 'AM';
                  return `${hour12}:${minutes} ${ampm}`;
                })()} & Available end time: {(() => {
                  const time = coach.academyAvailability.endTime;
                  const [hours, minutes] = time.split(':');
                  const hour12 = hours % 12 || 12;
                  const ampm = hours >= 12 ? 'PM' : 'AM';
                  return `${hour12}:${minutes} ${ampm}`;
                })()}
              </Text>
            )}

            {timingMode === "same" && (
              <Flex direction={{ base: "column", md: "row" }} alignItems={{ base: "stretch", md: "flex-start" }} gap={4} my={3} flexWrap="nowrap">
                <FormControl
                  flex={{ base: "none", md: 1 }}
                  minW={{ md: 0 }}
                  isInvalid={timeFromError}
                >
                  <FormLabel>Start Time 
                    <Text as="span" fontSize="sm"> (IST)</Text>
                    <Text as="span" color="red.500">*</Text>
                  </FormLabel>
                  <DatePicker
                    selected={timeFrom}
                    className={
                      timeFromError
                        ? "my-custom-datepicker dateError"
                        : "my-custom-datepicker"
                    }
                    onKeyDown={(e) => e.preventDefault()}
                    onChange={async (value) => {
                      if (value === "") {
                        setTimeFromError(true);
                      } else {
                        setTimeFromError(false);
                      }
                      setTimeFrom(value);
                      setTimeTo("");
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    placeholderText="Select time"
                    disabled={startDate === ""}
                    filterTime={filterTimeForStart}
                    timeClassName={(time) =>
                      filterTimeForStart(time) ? "enabled-time" : "disabled-time"
                    }
                  />
                </FormControl>
                <FormControl flex={{ base: "none", md: 1 }} minW={{ md: 0 }} isInvalid={timeToError}>
                  <FormLabel>End Time 
                    <Text as="span" fontSize="sm"> (IST)</Text>
                    <Text as="span" color="red.500">*</Text>
                  </FormLabel>
                  <DatePicker
                    key={timeFrom ? timeFrom.toString() : 'no-start-time'}
                    selected={timeTo}
                    onKeyDown={(e) => e.preventDefault()}
                    onChange={async (value) => {
                      await getAvailableSlots(`${id}`, "", value);
                      setTimeTo(value);
                      if (value === "") {
                        setTimeToError(true);
                      } else {
                        setTimeToError(false);
                      }
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    className={
                      timeToError
                        ? "my-custom-datepicker dateError"
                        : "my-custom-datepicker"
                    }
                    placeholderText="Select time"
                    disabled={timeFrom === ""}
                    filterTime={filterTimeForEnd}
                    timeClassName={(time) =>
                      filterTimeForEnd(time) ? "enabled-time" : "disabled-time"
                    }
                  />
                  {timeToError && (
                    <StyledFormErrorMessage>Select the time</StyledFormErrorMessage>
                  )}
                </FormControl>
              </Flex>
            )}

            {timingMode === "different" && selectedDays.length > 0 && (
              <FormControl my={4} isInvalid={daySchedulesError}>
                <FormLabel>Time for each selected day (IST) <Text as="span" color="red.500">*</Text></FormLabel>
                <VStack align="stretch" spacing={3} mt={2}>
                  {daySchedules.map((schedule) => (
                    <Flex
                      key={schedule.day}
                      direction={{ base: "column", sm: "row" }}
                      align={{ base: "stretch", sm: "center" }}
                      gap={3}
                      p={3}
                      borderRadius="md"
                      bg="gray.50"
                      borderWidth="1px"
                      borderColor="gray.200"
                    >
                      <Text fontWeight="600" minW="44px" color="blue.600">{schedule.day}</Text>
                      <Flex flex={1} gap={2} wrap="wrap">
                        <Box flex="1" minW="120px" position="relative" className="datepicker-time-wrapper">
                          <Text fontSize="xs" color="gray.600" mb={1}>Start</Text>
                          <DatePicker
                            key={`${schedule.day}-start`}
                            selected={schedule.startTime}
                            onChange={(value) => {
                              setDaySchedules((prev) =>
                                prev.map((s) =>
                                  s.day === schedule.day
                                    ? {
                                        ...s,
                                        startTime: value,
                                        // reset endTime so user selects a new one
                                        endTime: null,
                                      }
                                    : s
                                )
                              );
                              setDaySchedulesError(false);
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            dateFormat="h:mm aa"
                            placeholderText="Select time"
                            className="my-custom-datepicker"
                            onKeyDown={(e) => e.preventDefault()}
                            filterTime={(time) => filterTimeForStartPerDay(schedule, time)}
                            timeClassName={(time) =>
                              filterTimeForStartPerDay(schedule, time)
                                ? "enabled-time"
                                : "disabled-time"
                            }
                            popperClassName="datepicker-popper-inline"
                          />
                        </Box>
                        <Box flex="1" minW="120px" position="relative" className="datepicker-time-wrapper">
                          <Text fontSize="xs" color="gray.600" mb={1}>End</Text>
                          <DatePicker
                            key={`${schedule.day}-end`}
                            selected={schedule.endTime}
                            onChange={(value) => {
                              setDaySchedules((prev) =>
                                prev.map((s) =>
                                  s.day === schedule.day ? { ...s, endTime: value } : s
                                )
                              );
                              setDaySchedulesError(false);
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            dateFormat="h:mm aa"
                            placeholderText="Select time"
                            className="my-custom-datepicker"
                            onKeyDown={(e) => e.preventDefault()}
                            disabled={!schedule.startTime}
                            filterTime={(time) => isDifferentDayEndTimeAllowed(schedule, time)}
                            timeClassName={(time) =>
                              isDifferentDayEndTimeAllowed(schedule, time)
                                ? "enabled-time"
                                : "disabled-time"
                            }
                            popperClassName="datepicker-popper-inline"
                          />
                        </Box>
                      </Flex>
                    </Flex>
                  ))}
                </VStack>
                {daySchedulesError && (
                  <StyledFormErrorMessage>
                    Please set start and end time for each selected day (min 30 min gap).
                  </StyledFormErrorMessage>
                )}
              </FormControl>
            )}

            {timingMode === "different" && selectedDays.length === 0 && (
              <Text fontSize="sm" color="gray.500" my={2}>
                Select days above to set time for each day.
              </Text>
            )}

            {/* Conflicting Dates */}
            {showSlotConflict && (
              <Box my={4}>
                <Flex
                  justifyContent={"center"}
                  alignItems={"center"}
                  mb={2}
                >
                  <Text
                    color={"red.500"}
                    fontSize={"lg"}
                    fontWeight={"semibold"}
                  >
                    Conflicting Courses
                  </Text>
                </Flex>
                <TableContainer>
                  <Table variant="simple">
                    <Thead
                      bgColor={"#c1eaee"}
                      position={"sticky"}
                      top={"0px"}
                    >
                      <Tr bgColor={"red.100"}>
                        <Th>Start Date</Th>
                        <Th>End Date</Th>
                        <Th>Start Time</Th>
                        <Th>End Time</Th>
                        <Th>Days</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {groupConflictingDates(conflictResult?.conflictingDates ?? []).map(
                        (conflictDate, inx) => {
                          return (
                            <Tr bgColor={"gray.50"} key={inx}>
                              <Td>
                                {formatSlotDate(conflictDate?.startDate)}
                              </Td>
                              <Td>
                                {formatSlotDate(conflictDate?.endDate)}
                              </Td>
                              <Td>{conflictDate?.conflictingStartTime}</Td>
                              <Td>{conflictDate?.conflictingEndTime}</Td>
                              <Td>
                                <UnorderedList>
                                  {conflictDate?.conflictingDays?.map(
                                    (days, i) => {
                                      return (
                                        <ListItem key={i}>{days}</ListItem>
                                      );
                                    }
                                  )}
                                </UnorderedList>
                              </Td>
                            </Tr>
                          );
                        }
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {/* price */}
            {classType === "class" ? (
              <>
                <Flex
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <FormControl
                    my={4}
                    flexBasis={"30%"}
                    isInvalid={fees30Error}
                  >
                    <FormLabel>
                      Price <span>(30 minutes)</span>
                    </FormLabel>
                    <Tooltip
                      label={"Duration must be at least 30 minutes to enable this price"}
                      hasArrow
                      isDisabled={!showTooltip30}
                    >
                      <Input
                        type="number"
                        name="price"
                        id="price"
                        placeholder="₹0"
                        value={fees30}
                        autoComplete="off"
                        isDisabled={!priceFieldsEnabled.price30}
                        onChange={(e) => {
                        let newValue = e.target.value;
                        newValue = newValue.replace(/[^\d.]/g, "");
                        newValue = newValue.replace(/^0+/, "");
                        newValue = newValue.replace(/^\./, "");
                        if (newValue.includes(".")) {
                          newValue = newValue.split(".")[0];
                        }
                        setFees30(newValue);
                        if (newValue !== "") {
                          clearFeeErrors();
                        }
                        const f30 = priceFieldsEnabled.price30 ? newValue : null;
                        const f45 = priceFieldsEnabled.price45 ? fees45 : null;
                        const f60 = priceFieldsEnabled.price60 ? fees60 : null;

                        if (!f30 && !f45 && !f60) {
                          setFees30Error(true);
                        }
                      }}
                    />
                    </Tooltip>
                    {fees30Error && (
                      <StyledFormErrorMessage>
                        Please enter the price
                      </StyledFormErrorMessage>
                    )}
                  </FormControl>
                  <FormControl
                    my={4}
                    flexBasis={"30%"}
                    isInvalid={fees45Error}
                  >
                    <FormLabel>
                      Price <span>(45 minutes)</span>
                    </FormLabel>
                    <Tooltip
                      label={"Duration must be at least 45 minutes to enable this price"}
                      hasArrow
                      isDisabled={!showTooltip45}
                    >
                      <Input
                        type="number"
                        name="price"
                        id="price"
                        placeholder="₹0"
                        value={fees45}
                        autoComplete="off"
                        isDisabled={!priceFieldsEnabled.price45}
                        onChange={(e) => {
                        let newValue = e.target.value;
                        newValue = newValue.replace(/[^\d.]/g, "");
                        newValue = newValue.replace(/^0+/, "");
                        newValue = newValue.replace(/^\./, "");
                        if (newValue.includes(".")) {
                          newValue = newValue.split(".")[0];
                        }
                        setFees45(newValue);
                        if (newValue !== "") {
                          clearFeeErrors();
                        }
                        const f30 = priceFieldsEnabled.price30 ? fees30 : null;
                        const f45 = priceFieldsEnabled.price45 ? newValue : null;
                        const f60 = priceFieldsEnabled.price60 ? fees60 : null;

                        if (!f30 && !f45 && !f60) {
                          setFees45Error(true);
                        }
                      }}
                      />
                    </Tooltip>
                    {fees45Error && (
                      <StyledFormErrorMessage>
                        Please enter the price
                      </StyledFormErrorMessage>
                    )}
                  </FormControl>
                  <FormControl
                    my={4}
                    flexBasis={"30%"}
                    isInvalid={fees60Error}
                  >
                    <FormLabel>
                      Price <span>(60 minutes)</span>
                    </FormLabel>
                    <Tooltip
                      label={"Duration must be at least 60 minutes to enable this price"}
                      hasArrow
                      isDisabled={!showTooltip60}
                    >
                      <Input
                        type="number"
                        name="price"
                        id="price"
                        placeholder="₹0"
                        min={0}
                        step={1}
                        value={fees60}
                        autoComplete="off"
                        isDisabled={!priceFieldsEnabled.price60}
                        onChange={(e) => {
                        let newValue = e.target.value;
                        newValue = newValue.replace(/[^\d.]/g, "");
                        newValue = newValue.replace(/^0+/, "");
                        newValue = newValue.replace(/^\./, "");
                        if (newValue.includes(".")) {
                          newValue = newValue.split(".")[0];
                        }
                        setFees60(newValue);
                        if (newValue !== "") {
                          clearFeeErrors();
                        }
                        const f30 = priceFieldsEnabled.price30 ? fees30 : null;
                        const f45 = priceFieldsEnabled.price45 ? fees45 : null;
                        const f60 = priceFieldsEnabled.price60 ? newValue : null;

                        if (!f30 && !f45 && !f60) {
                          setFees60Error(true);
                        }
                      }}
                      />
                    </Tooltip>
                    {fees60Error && (
                      <StyledFormErrorMessage>
                        Please enter price
                      </StyledFormErrorMessage>
                    )}
                  </FormControl>
                </Flex>
              </>
            ) : (
              <FormControl my={4} isInvalid={priceError}>
                <FormLabel>Price <Text as="span" color="red.500">*</Text></FormLabel>
                <Tooltip
                  label={"Duration must be at least 30 minutes to enable price"}
                  hasArrow
                  isDisabled={!showTooltipCoursePrice}
                >
                  <Input
                    type="number"
                    name="price"
                    id="price"
                    placeholder="₹0.00"
                    value={price}
                    autoComplete="off"
                    isDisabled={!priceFieldsEnabled.coursePrice}
                    onChange={(e) => {
                      let newValue = e.target.value;
                      newValue = newValue.replace(/[^\d.]/g, "");
                      newValue = newValue.replace(/^0+/, "");
                      newValue = newValue.replace(/^\./, "");
                      if (newValue.includes(".")) {
                        newValue = newValue.split(".")[0];
                      }
                      setPrice(newValue);
                      if (e.target.value !== "") {
                        setPriceError(false);
                      } else {
                        setPriceError(true);
                      }
                    }}
                  />
                </Tooltip>
                {priceError && (
                  <StyledFormErrorMessage>
                    Please enter the price
                  </StyledFormErrorMessage>
                )}
              </FormControl>
            )}
          </CardBody>
        </Card>
        <Card mt={4}>
          <CardBody>
            {/* Session type if -- Course */}
            {classType === "course" && (
              <FormControl mt={6}>
                <FormLabel>Session Type</FormLabel>
                <Select
                  value={sessionType}
                  onChange={(e) => {
                    setSessionType(e.target.value);
                    setMaximumGroupSize(1);
                  }}
                >
                  <option value="Group">Group</option>
                  <option value="Individual">Individual</option>
                </Select>
              </FormControl>
            )}

            {/* Is it a camp if --- Course */}
            {classType !== "class" && (
              <>
                <Flex
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  mt={4}
                  mb={2}
                >
                  <Text
                    fontWeight={"semibold"}
                    fontSize={"16px"}
                    mb={1}
                    mr={4}
                  >
                    Is it a camp ?{" "}
                  </Text>
                  <Box mr={4}>
                    <input
                      type="radio"
                      id="yes"
                      name="camp-type"
                      value="yes"
                      onChange={handleRadioChange}
                      style={{ marginTop: "2px" }}
                    />
                    <label
                      htmlFor="yes"
                      style={{ marginLeft: "8px", cursor: "pointer" }}
                    >
                      Yes
                    </label>
                  </Box>
                  <Box>
                    <input
                      type="radio"
                      id="no"
                      name="camp-type"
                      value="no"
                      onChange={handleRadioChange}
                      defaultChecked
                      style={{ marginTop: "2px" }}
                    />
                    <label
                      htmlFor="no"
                      style={{ marginLeft: "8px", cursor: "pointer" }}
                    >
                      No
                    </label>
                  </Box>
                </Flex>
                {isItCamp && (
                  <FormControl isInvalid={campNameError}>
                    <Input
                      type="text"
                      name="camp-name"
                      id="camp-name"
                      value={campName}
                      autoComplete="off"
                      placeholder="Enter camp name"
                      onChange={(e) => {
                        setCampName(e.target.value);
                        if (e.target.value !== "") {
                          setCampNameError(false);
                        } else {
                          setCampNameError(true);
                        }
                        if (
                          e.target.value.length > 100 ||
                          e.target.value.length < 3
                        ) {
                          setCampNameError(true);
                        } else {
                          setCampNameError(false);
                        }
                      }}
                    />
                    {campNameError && (
                      <StyledFormErrorMessage>
                        Please enter camp name characters must be greater
                        than or equal to 3 and less than equal to 100
                      </StyledFormErrorMessage>
                    )}
                  </FormControl>
                )}
              </>
            )}

            {/* Category */}
            <FormControl mt={6} isInvalid={categoryError}>
              <FormLabel>Category <Text as="span" color="red.500">*</Text></FormLabel>
              <Select
                placeholder="Select Category"
                onChange={(e) => {
                  setCategoryType(e.target.value);
                  setCategoryError(false);
                }}
              >
                {categories?.map((category, inx) => (
                  <option key={inx} value={category?.name}>
                    {category?.name}
                  </option>
                ))}
              </Select>
              {categoryError && (
                <StyledFormErrorMessage>Please select category</StyledFormErrorMessage>
              )}
            </FormControl>
            {/* Select Facility */}
            <FormControl mt={6} isInvalid={facilityError}>
              <FormLabel>Facility <Text as="span" color="red.500">*</Text></FormLabel>
              <Select
                placeholder="Select Facility"
                value={courseFacility}
                onChange={(e) => {
                  setCourseFacility(e?.target?.value);
                  setFacilityError(false);
                  setCourseAmeneties(
                    facilities.filter((x) => x.name === e.target.value)[0]
                      .amenities
                  );
                }}
              >
                {facilities.map((facility, inx) => (
                  <option key={inx} value={facility.name}>
                    {facility.name}
                  </option>
                ))}
              </Select>
              {facilityError && (
                <StyledFormErrorMessage>Please select facility</StyledFormErrorMessage>
              )}
            </FormControl>

            {/* Max group size */}
            {sessionType === "Group" && classType === "course" && (
              <FormControl mt={6} isInvalid={maximumGroupSizeError}>
                <FormLabel>Maximum Group Size (1-20)</FormLabel>
                <Input
                  type="number"
                  placeholder="Enter maximum group size (1-20)"
                  name="max-group-size"
                  id="max-group-size"
                  value={maximumGroupSize}
                  min="1"
                  max="20"
                  onChange={(e) => {
                    const raw = e.target.value || "";
                    const digits = raw.replace(/\D/g, "");

                    if (digits === "") {
                      setMaximumGroupSize("");
                      setMaximumGroupSizeError(true);
                      return;
                    }

                    const numValue = parseInt(digits, 10);
                    if (isNaN(numValue)) return;

                    if (numValue < 1) {
                      setMaximumGroupSize(1);
                      setMaximumGroupSizeError(false);
                    } else if (numValue > 20) {
                      setMaximumGroupSize(20);
                      setMaximumGroupSizeError(false);
                    } else {
                      setMaximumGroupSize(numValue);
                      setMaximumGroupSizeError(false);
                    }
                  }}
                  onBlur={(e) => {
                    // Ensure value is set to 1 if empty on blur
                    if (e.target.value === "" || parseInt(e.target.value, 10) < 1) {
                      setMaximumGroupSize(1);
                      setMaximumGroupSizeError(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '+' || e.key === '-' || e.key === '.' || e.key === 'e' || e.key === 'E') {
                      e.preventDefault();
                      return;
                    }
                    if (e.key === '0' && e.target.value === '') {
                      e.preventDefault();
                      return;
                    }
                    const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'];
                    if (allowed.includes(e.key)) return;
                    // Allow only digits 0-9
                    if (!/^[0-9]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {maximumGroupSizeError && (
                  <StyledFormErrorMessage>
                    Please enter maximum group size between 1 and 20
                  </StyledFormErrorMessage>
                )}
              </FormControl>
            )}
            {/* Proficiency Level */}

            <FormControl mt={6}>
              <FormLabel>Proficiency Level <Text as="span" color="red.500">*</Text></FormLabel>
              <Box position="relative" id="proficiency-menu">
                <Button
                  w={"100%"}
                  rightIcon={<FaChevronDown />}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsProficiencyMenuOpen(!isProficiencyMenuOpen);
                  }}
                >
                  {proficiencyLevel.length > 0
                    ? `${proficiencyLevel.length} selected`
                    : "Select Proficiency Level(s)"}
                </Button>
                
                {isProficiencyMenuOpen && (
                  <Box
                    position="absolute"
                    top="100%"
                    left={0}
                    right={0}
                    bg="white"
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    boxShadow="lg"
                    zIndex={1000}
                    mt={1}
                    minW={window.innerWidth - 600 + "px"}
                  >
                    <Box p={2}>
                      {proficiencyLevelOption?.map((proficiency, i) => (
                        <Box p={2} key={i}>
                          <Checkbox
                            size="md"
                            colorScheme="green"
                            value={proficiency.value}
                            isChecked={proficiencyLevel.includes(proficiency.value)}
                            onChange={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const isChecked = e.target.checked;
                              const value = proficiency.value;
                              
                              if (isChecked) {
                                // Add to proficiency level if not already present
                                if (!proficiencyLevel.includes(value)) {
                                  const newLevels = [...proficiencyLevel, value];
                                  setProficiencyLevel(newLevels);
                                }
                              } else {
                                // Remove from proficiency level
                                const newLevels = proficiencyLevel.filter(level => level !== value);
                                setProficiencyLevel(newLevels);
                              }
                            }}
                          >
                            {proficiency.name}
                          </Checkbox>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>

              <HStack spacing={4} mt={2} flexWrap="wrap">
                {proficiencyLevel && proficiencyLevel.length > 0 &&
                  proficiencyLevel.map((level, index) => {
                    const levelOption = proficiencyLevelOption.find(opt => opt.value === level);
                    return (
                      <Tag
                        key={index}
                        size={"md"}
                        variant="solid"
                        colorScheme="teal"
                        mb={1}
                      >
                        {levelOption?.name || level}
                      </Tag>
                    );
                  })
                }
              </HStack>
            </FormControl>

            {/* Ameneties */}
            <FormControl mt={6}>
              <FormLabel>Amenities</FormLabel>
              <ReactQuill
                theme="snow"
                value={courseAmeneties}
                onChange={(value) => {
                  setCourseAmeneties(value);
                }}
              />
            </FormControl>
            {/* Thing Have to Carry with */}
            <FormControl mt={6}>
              <FormLabel>Thing Have to Carry with</FormLabel>
              <ReactQuill
                theme="snow"
                value={carryThings}
                onChange={(value) => {
                  setCarryThings(value);
                }}
              />
            </FormControl>
            {/* Cancellation Policy */}
            <FormControl mt={6}>
              <FormLabel>Cancellation Policy</FormLabel>
              <ReactQuill
                theme="snow"
                value={cancellationPolicy}
                onChange={(value) => {
                  setCancellationPolicy(value);
                }}
              />
            </FormControl>
          </CardBody>
        </Card>
        <Flex
          mt={4}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={4}
          direction={{ base: "column", md: "row" }}
        >
          <Button
            variant={"solid"}
            colorScheme="red"
            size={isMobile ? "lg" : "md"}
            px={8}
            flex={{ base: "1", md: "0 0 49%" }}
            onClick={onOpen3}
            disabled={btnIsLoading}
            height={isMobile ? "48px" : "40px"}
            minHeight={isMobile ? "48px" : "40px"}
            _disabled={{
              opacity: 0.6,
              cursor: "not-allowed",
            }}
          >
            Discard
          </Button>
          <Button
            variant={"solid"}
            colorScheme="green"
            size={isMobile ? "lg" : "md"}
            px={8}
            ml={{ base: 0, md: 4 }}
            isLoading={btnIsLoading}
            loadingText="Submitting..."
            onClick={saveHandler}
            flex={{ base: "1", md: "0 0 49%" }}
            disabled={btnIsLoading}
            height={isMobile ? "48px" : "40px"}
            minHeight={isMobile ? "48px" : "40px"}
            _disabled={{
              opacity: 0.6,
              cursor: "not-allowed",
            }}
            // iOS specific fixes
            _focus={{
              boxShadow: "none",
            }}
            _active={{
              transform: "none",
            }}
            style={{
              WebkitAppearance: "none",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            Submit
          </Button>
        </Flex>

        {/* Discard */}
        <AlertDialog isOpen={isOpen3} onClose={onClose3} isCentered>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Discard Changes
              </AlertDialogHeader>

              <AlertDialogBody>
                Are you sure? You can't undo this action afterwards.
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button
                  colorScheme="red"
                  onClick={() => {
                    onClose3();
                  }}
                >
                  No
                </Button>
                <Button
                  colorScheme="green"
                  onClick={() => {
                    onClose3();
                    navigate(-1);
                  }}
                  ml={3}
                >
                  Yes
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Layout>
    </Box>
  );
};

export default CourseCreation;